// CONSTANTS are all caps.
const CLS_ACTIVE = 'is-active';
const CLS_SHOW_CONFIRM = 'is-active';
import * as Api from '../../../../global/js/api';
import {updatePriceItem, refreshBonusBuyBadge} from '../../../../global/js/cart';
import {getEpiRecommendations} from '../../../../global/js/epiTrack';
import {RecommendationsBlock} from '../../../blocks/recommendationsBlock/js/recommendationsBlock';
import {QuantityInput} from '../../quantityInput/js/quantityInput';

export const UPDATE_CART = 'updateCartHeader';
export function updateHeaderCart(count) {
	if (count !== null) {
		const $cartCount = $('.js-cartCount');
		if ($cartCount.length && count) {
			$cartCount.removeClass('invisible').text(count);
		} else if ($cartCount.length ) {
			$cartCount.addClass('invisible').text(count);
		}
	}
	HeaderCart.updateHeaderCartView();
}

export class HeaderCart {
	constructor($el) {
		this.$el = $el;
		this.$wg = $($el);
	}

	init() {
		this.registerEvent();
		this.initRecommendationsBlock();
		this.updateSwiper();
	}

	registerEvent() {
		const This = this;

		this.$wg.on('click', '.btn-up:not(.disabled), .btn-down', function() {
			const item = $(this).closest('.cart-item');
			const currentVal = item.find('.quantityInput input').val();
			const prevQuantity = item.data('prevQuantity');
			if (prevQuantity !== currentVal) {
				This.updateItemQuantity(item);
				item.data('prevQuantity', currentVal);
			}
		});

		this.$wg.on('click', '.cart-button-remove', function() {
			const item = $(this).closest('.cart-item');
			item.find('.remove-overlay').addClass(CLS_SHOW_CONFIRM);
		});

		this.$wg.on('click', '.cancel-button', function() {
			const item = $(this).closest('.cart-item');
			item.find('.remove-overlay').removeClass(CLS_SHOW_CONFIRM);
		});

		this.$wg.on('click', '.remove-confirm', function() {
			const item = $(this).closest('.cart-item');
			This.removeCartItem(item);
		});

		$(document).on(UPDATE_CART, function() {
			const getMiniCartDetails = This.$wg.data('getMiniCartDetails');
			Api.getHtml(getMiniCartDetails).then((html) => {
				const $cartContent = This.$wg.find('.cart-content');
				let lineItemsCount = 0;

				$cartContent.html(html);
				$cartContent.find('[data-wg="QuantityInput"]').each(function() {
					const quantityInput = new QuantityInput(this);
					quantityInput.init();
				});

				This.initRecommendationsBlock();

				$cartContent.find('.cart-item').each(function() {
					lineItemsCount = lineItemsCount + $(this).data('quantityInit');
				});

				This.updateLineItemsCount(lineItemsCount);
			});
		});
	}

	initRecommendationsBlock() {
		const $recommendationsBlock = this.$wg.find('[data-blk="RecommendationsHeader"]');
		$recommendationsBlock.length && getEpiRecommendations($recommendationsBlock, () => {
			const recommendationsBlock = new RecommendationsBlock($recommendationsBlock[0]);
			recommendationsBlock.init();
		});
	}

	updateSwiper() {
		const $li = this.$wg.closest('li');
		$li.on('click', function() {
			const hasSwiper = $li.hasClass('active') && $li.find('.swiper-container').length && $li.find('.swiper-container')[0].swiper;
			if (hasSwiper) {
				$li.find('.swiper-container')[0].swiper.update();
			}
		});
	}

	removeCartItem(item) {
		const This = this;
		$('.loading-spinner').addClass(CLS_ACTIVE);
		this.removeCartItemCall(item).then(function(data) {
			HeaderCart.updateHeaderCartView();
			$('.loading-spinner').removeClass(CLS_ACTIVE);
		}).catch(function() {
			$('.loading-spinner').removeClass(CLS_ACTIVE);
		});
	}

	static updateHeaderCartView() {
		$(document).trigger(UPDATE_CART);
	}

	handleMessageItem(data, $item) {
		if (data.message) {
			$item.find('.error-messages').addClass(CLS_ACTIVE).text(data.message);
			$item.find('.quantityInput input').val(data.quantity);
			$item.find('.quantityInput .btn-up').addClass('disabled');
		} else {
			$item.find('.error-messages').removeClass(CLS_ACTIVE).text('');
			$item.find('.quantityInput .btn-up').removeClass('disabled');
		}
	}

	removeCartItemCall(item) {
		const removeItemApiEndpoint = item.data('removeItemApiEndpoint');
		const id = item.data('id');
		const data = {
			id,
		};

		return Api.callApi(removeItemApiEndpoint, data);
	}

	updateItemQuantity(item) {
		const This = this;
		$('.loading-spinner').addClass(CLS_ACTIVE);
		this.updateItemQuantityCall(item).then(function(data) {
			HeaderCart.updateHeaderCartView();
			$('.loading-spinner').removeClass(CLS_ACTIVE);
		}).catch(function() {
			$('.loading-spinner').removeClass(CLS_ACTIVE);
		});
	}

	updateItemQuantityCall(item) {
		const quantity = item.find('.quantityInput input').val();
		const updateItemApiEndpoint = item.data('updateItemApiEndpoint');
		const id = item.data('id');
		const data = {
			id,
			quantity,
		};

		return Api.callApi(updateItemApiEndpoint, data);
	}

	updateTotal(subtotal) {
		const subtotalText = parseFloat(subtotal).toFixed(2);
		this.$wg.find('.cart-summary-price').text(`$${subtotalText}`);
	}

	updateLineItemsCount(lineitemscount) {
		const $siteHeaderCartCount = $('.js-cartCount');
		if (lineitemscount == 0) {
			$siteHeaderCartCount.text(lineitemscount).addClass('invisible');
		} else {
			$siteHeaderCartCount.text(lineitemscount).removeClass('invisible');
		}
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/widgets/headerCart/js/headerCart.js